import script from "./edit.vue?vue&type=script&setup=true&lang=js"
export * from "./edit.vue?vue&type=script&setup=true&lang=js"

import "./edit.vue?vue&type=style&index=0&id=3edcd5ae&lang=scss&scoped=true"
import "./edit.vue?vue&type=style&index=1&id=3edcd5ae&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3edcd5ae"]])

export default __exports__